import { useEffect, useState } from "react";

const wrapCallbacks = (apiCallbacks, setCurrentCallback) => {
  const callbackNames = Object.keys(apiCallbacks);
  const triggers = {};
  callbackNames.forEach(name => {
    triggers[name] = (...params) => {
      const promise = new Promise(resolve => {
        setCurrentCallback({
          callback: apiCallbacks[name],
          params,
          resolve,
          name
        });
      });
      return promise;
    };
  });
  return triggers;
};

export default function useResource(apiCallbacks) {
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentCallback, setCurrentCallback] = useState(null);
  const [callbackTriggers, setCallbackTriggers] = useState(
    wrapCallbacks(apiCallbacks, setCurrentCallback)
  );

  useEffect(() => {
    setCallbackTriggers(wrapCallbacks(apiCallbacks, setCurrentCallback));
  }, [apiCallbacks]);

  useEffect(() => {
    if (currentCallback) {
      const fetchData = async () => {
        setIsLoading(true);
        try {
          const response = await currentCallback.callback(
            ...currentCallback.params
          );
          setResponse(response);
          setIsLoading(false);
        } catch (exception) {
          setIsLoading(false);
          return;
        }
      };
      fetchData();
    }
  }, [currentCallback]);

  useEffect(() => {
    if (!isLoading && currentCallback) {
      const resolve = currentCallback.resolve;
      setCurrentCallback(null);
      resolve(response);
    }
  }, [isLoading]);

  return [
    response || {},
    callbackTriggers,
    currentCallback ? callbackTriggers[currentCallback.name] : null
  ];
}
